import { Text, Box, Flex, Heading, Container } from "theme-ui"
import { MagicLink } from "../utils/magicLink"
import { useBreakpointIndex } from "@theme-ui/match-media"
import Texture from "../assets/images/texture.svg"
import { ArrowRightCircle } from "react-feather"
import React from "react"
import { OutboundLink } from "./link"
const BannerTop = ({}) => {
  const breakpointIndex = useBreakpointIndex()
  return (
    <Box
      sx={{
        position: "relative",
        top: "0",
        backgroundColor: "primary",
        width: "100%",
        a: {
          textDecoration: "none",
        },
        // backgroundImage: 'url("../assets/images/texture.svg"',
        // backgroundRepeat: "no-repeat",
        // backgroundPosition: "right",
        // backgroundSize: "25%",
        // "@media screen and (max-width: 1300px)": {
        //   backgroundImage: "none",
        // },
      }}
    >
      <Container sx={{ py: [2, 2, 2, 2], textAlign: "center" }}>
        <Flex sx={{ gap: 8, alignItems: "center" }}>
          <Box>
            <Heading
              as="h3"
              variant="h4"
              sx={{ my: [0], fontSize: [1, 5], color: "light" }}
            >
              Rivoluziona la pulizia industriale con Socaf
            </Heading>
          </Box>
          <Flex>
            <Box sx={{ height: "100%", a: { display: "flex" } }}>
              <OutboundLink to="https://shop.socaf.it/login">
                <Flex
                  sx={{
                    minHeight: "31px",
                    px: [2, 3],
                    py: [1, 2],
                    fontSize: [0, 1, 1, 2],
                    textDecoration: "none",
                    cursor: "pointer",
                    backgroundColor: "light",
                    color: "primary",
                    border: "1px solid",
                    borderColor: "light",

                    transition: "background-color .2s linear",
                    "&:hover": {
                      color: "light",
                      bg: "dark",
                    },
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Flex
                    sx={{
                      gap: 3,
                      alignItems: "center",
                    }}
                  >
                    <Text>Scopri il nostro E-commerce </Text>{" "}
                    <ArrowRightCircle />
                  </Flex>
                </Flex>
              </OutboundLink>
            </Box>
            {breakpointIndex > 2 && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  top: 0,
                  right: 0,

                  display: "flex",
                  justifyContent: "flex-end",

                  height: "100%",
                  svg: {
                    height: "100%",
                    width: "100%",
                  },
                  "@media screen and (max-width: 1300px)": {
                    display: "none",
                  },
                }}
              >
                <Texture />
              </Box>
            )}
          </Flex>
        </Flex>
      </Container>
    </Box>
  )
}

export default BannerTop
